import React from 'react';
import { ReportsList } from 'components/Reports';
import useIsMobile from 'hooks/useIsMobile';

const Reports = () => {
  const isMobile = useIsMobile();

  return (
    <div style={{
      height: isMobile ? 'calc(100vh - 120px)' : 'calc(100vh - 140px)',
      overflow: 'auto',
      padding: isMobile ? '0 5px' : '0 10px'
    }}>
      <ReportsList />
    </div>
  );
};

export default Reports;
